import React from "react";
import { Card, Col, Container, Row, Button } from "react-bootstrap";
import { AwardFill, CheckCircleFill, PhoneFill, Shop, GeoAltFill, Hammer } from "react-bootstrap-icons";
//import buildingImage from "../../utils/punto-fisico.webp";
import { useCompanyInfo } from "../../hooks/useCompanyInfo";

const AboutUs = () => {
    const { companyData } = useCompanyInfo();

    const storeAddress = `${companyData.direccion} ${companyData.ciudad} - ${companyData.departamento}`;
    const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(storeAddress)}`;
    const buildingImage = 'https://imagenes-tubisnez.s3.us-east-2.amazonaws.com/punto-fisico.webp';

    return (
        <>
            {/* SVG de transición en forma de onda invertida */}
            <svg viewBox="0 -1 1440 320" className="wave-transition wave-transition-top" xmlns="http://www.w3.org/2000/svg">
                <path fill="#2b235e" fillOpacity="1" d="M0,96L40,90.7C80,85,160,75,240,106.7C320,139,400,213,480,213.3C560,213,640,139,720,128C800,117,880,171,960,202.7C1040,235,1120,245,1200,240C1280,235,1360,213,1400,202.7L1440,192L1440,320L1400,320C1360,320,1280,320,1200,320C1120,320,1040,320,960,320C880,320,800,320,720,320C640,320,560,320,480,320C400,320,320,320,240,320C160,320,80,320,40,320L0,320Z"></path>
            </svg>

            {/* Sección principal con fondo color SVG */}
            <div style={{ backgroundColor: '#2b235e' }} >
                <Container>
                    <Row className="align-items-center ">
                        {/* Texto a la izquierda */}
                        <Col lg={6} className="mb-4 mb-lg-0 mt-4">
                            <h2 className="text-uppercase text-white-50 mb-3 fs-6">Acerca de Nosotros</h2>
                            <h3 className="fw-bold text-white fs-1 mb-4">Somos Fabricantes de Gorras en Colombia</h3>
                            <p className="text-white-50 fs-5 lh-lg">
                                Somos una fábrica líder en la fabricación de gorras de alta calidad en Colombia.
                                Diseñamos y producimos cada pieza con materiales premium y acabados impecables,
                                garantizando durabilidad, comodidad y estilo en cada producto.
                            </p>
                            <p className="text-white-50 fs-5 lh-lg">
                                Desde hace años, vestimos a miles de clientes con gorras que combinan tendencia,
                                calidad y precio competitivo. ¡Lleva directamente de fábrica a ti!
                            </p>
                        </Col>

                        {/* Imagen de edificio a la derecha */}
                        <Col lg={6}>
                            <div className="position-relative">
                                <img
                                    src={buildingImage}
                                    alt="Nuestro local"
                                    className="w-100 rounded-4 shadow-lg"
                                    style={{ objectFit: 'cover', maxHeight: '400px' }}
                                />
                                <div className="position-absolute bottom-0 start-0 w-100 p-4" style={{ background: 'linear-gradient(transparent, rgba(0, 0, 0, 0.89))', borderBottomLeftRadius: '16px', borderBottomRightRadius: '16px' }}>
                                    <div className="d-flex align-items-center text-white mb-2">
                                        <Shop size={32} className="text-light me-3" />
                                        <div>
                                            <h5 className="mb-0 fw-bold">Tienda Física</h5>
                                            <small className="text-white">{storeAddress}</small>
                                        </div>
                                    </div>
                                    <Button
                                        variant="danger"
                                        size="sm"
                                        className="d-flex align-items-center"
                                        href={googleMapsUrl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <GeoAltFill className="me-2" />
                                        Cómo llegar
                                    </Button>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>

            {/* SVG de transición en forma de onda */}
            <svg viewBox="0 0 1440 320" className="wave-transition wave-transition-bot" style={{ marginBottom: "-5px" }} xmlns="http://www.w3.org/2000/svg">
                <path fill="#2b235e" fillOpacity="1" d="M0,128L40,133.3C80,139,160,149,240,176C320,203,400,245,480,240C560,235,640,181,720,160C800,139,880,149,960,165.3C1040,181,1120,203,1200,213.3C1280,224,1360,224,1400,224L1440,224L1440,0L1400,0C1360,0,1280,0,1200,0C1120,0,1040,0,960,0C880,0,800,0,720,0C640,0,560,0,480,0C400,0,320,0,240,0C160,0,80,0,40,0L0,0Z"></path>
            </svg>

            {/* Sección de beneficios */}
            <div>
                <Container>
                    <h4 className="text-center fw-bold fs-2 text1-cr mb-2 mb-md-5">¿Por qué comprar con nosotros?</h4>
                    <Row>
                        {/* Tarjeta 1 - Fabricantes */}
                        <Col md={3} className="mb-4">
                            <Card className="bg-white h-100 p-4 border-0 shadow-sm">
                                <Card.Body className="text-center">
                                    <div className="mb-3">
                                        <Hammer size={48} className="text-danger" />
                                    </div>
                                    <Card.Title className="fw-bold mb-3 text1-cr">Fabricantes Directos</Card.Title>
                                    <Card.Text className="text-muted">
                                        Somos fábrica. Sin intermediarios, precios de fábrica directamente para ti.
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                        </Col>
                        {/* Tarjeta 2 */}
                        <Col md={3} className="mb-4">
                            <Card className="bg-white h-100 p-4 border-0 shadow-sm">
                                <Card.Body className="text-center">
                                    <div className="mb-3">
                                        <CheckCircleFill size={48} className="text-danger" />
                                    </div>
                                    <Card.Title className="fw-bold mb-3 text1-cr">Calidad Premium</Card.Title>
                                    <Card.Text className="text-muted">
                                        Materiales de primera calidad y acabados impecables en cada gorra.
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                        </Col>
                        {/* Tarjeta 3 */}
                        <Col md={3} className="mb-4">
                            <Card className="bg-white h-100 p-4 border-0 shadow-sm">
                                <Card.Body className="text-center">
                                    <div className="mb-3">
                                        <PhoneFill size={48} className="text-danger" />
                                    </div>
                                    <Card.Title className="fw-bold mb-3 text1-cr">Atención Personalizada</Card.Title>
                                    <Card.Text className="text-muted">
                                        Te asesoramos para encontrar la gorra perfecta para ti.
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                        </Col>
                        {/* Tarjeta 4 */}
                        <Col md={3} className="mb-4">
                            <Card className="bg-white h-100 p-4 border-0 shadow-sm">
                                <Card.Body className="text-center">
                                    <div className="mb-3">
                                        <AwardFill size={48} className="text-danger" />
                                    </div>
                                    <Card.Title className="fw-bold mb-3 text1-cr">Garantía de Satisfacción</Card.Title>
                                    <Card.Text className="text-muted">
                                        Tu satisfacción es nuestra prioridad. Compra con confianza.
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    );
};

export default AboutUs;
